export const DISCIPLINE_LABEL = {
  muay_thai_educatif: "🥊 Kickboxing/Muaythai",
  kickboxing_educatif: "🥊 Kickboxing/Muaythai",
  jjb: "🥋 Jiu-Jitsu Brésilien",
  can_ryu_demo: "🇯🇵 Jiu-jitsu Can Ryu (démo)",
  petits_samourais: "🐣 Petits Samouraïs (parcours 3-6 ans)",
};
export const BELTS = ["blanche", "grise", "jaune", "orange", "verte", "bleue", "mauve", "brune", "noire"];
export const STEP_LABELS = ["Identité", "Dojo", "Profil sportif", "Disciplines", "Poids & catégorie", "Disponibilités", "Santé & sécurité", "Règlements", "Autorisations", "Paiement", "Confirmation"];

const inp = "w-full rounded-xl bg-zinc-900 border border-white/10 p-3 text-sm";
const lbl = "block text-xs uppercase tracking-widest text-zinc-400 mb-1";

export function Field({ label, children, hint }) {
  return (
    <div>
      <label className={lbl}>{label}</label>
      {children}
      {hint && <p className="text-[11px] text-zinc-500 mt-1">{hint}</p>}
    </div>
  );
}

export function Txt({ k, d, set, type = "text", placeholder = "", testid }) {
  return <input data-testid={testid || `jm-${k}`} type={type} value={d[k] ?? ""} placeholder={placeholder} onChange={(e) => set(k, e.target.value)} className={inp} />;
}

export function Check({ k, d, set, label, testid }) {
  return (
    <label className="flex items-start gap-2 text-sm cursor-pointer">
      <input type="checkbox" data-testid={testid || `jm-${k}`} checked={!!d[k]} onChange={(e) => set(k, e.target.checked)} className="w-4 h-4 mt-0.5 accent-[#D90429]" />
      <span>{label}</span>
    </label>
  );
}

export function ageAt(dob, eventDate) {
  if (!dob || !eventDate) return null;
  return Math.floor((new Date(eventDate) - new Date(dob)) / (365.25 * 24 * 3600 * 1000));
}

export function StepIdentite({ d, set, event }) {
  const age = ageAt(d.athlete_dob, event?.date);
  const minor = age !== null && age < 18;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <Field label="Prénom *"><Txt k="athlete_first_name" d={d} set={set} /></Field>
        <Field label="Nom *"><Txt k="athlete_last_name" d={d} set={set} /></Field>
        <Field label="Date de naissance *"><Txt k="athlete_dob" d={d} set={set} type="date" /></Field>
        <Field label="Sexe / catégorie *">
          <select data-testid="jm-athlete_gender" value={d.athlete_gender || ""} onChange={(e) => set("athlete_gender", e.target.value)} className={inp}>
            <option value="">—</option><option value="F">Fille / Femme</option><option value="M">Garçon / Homme</option><option value="X">Autre</option>
          </select>
        </Field>
        <Field label="Courriel athlète"><Txt k="athlete_email" d={d} set={set} type="email" /></Field>
        <Field label="Téléphone athlète"><Txt k="athlete_phone" d={d} set={set} type="tel" /></Field>
      </div>
      <Field label="Adresse"><Txt k="address" d={d} set={set} placeholder="Rue, ville, code postal" /></Field>
      {age !== null && <p className="text-xs text-zinc-400" data-testid="jm-age-info">Âge le jour de l'événement : <b className="text-white">{age} ans</b>{minor && " — parent / tuteur obligatoire"}</p>}
      {(minor || age === null) && (
        <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-3 grid grid-cols-2 gap-3" data-testid="jm-parent-block">
          <div className="col-span-2 text-xs text-amber-300 font-semibold">Parent / tuteur légal {minor ? "*" : "(si mineur)"}</div>
          <Field label="Nom"><Txt k="parent_name" d={d} set={set} /></Field>
          <Field label="Téléphone"><Txt k="parent_phone" d={d} set={set} type="tel" /></Field>
          <div className="col-span-2"><Field label="Courriel"><Txt k="parent_email" d={d} set={set} type="email" /></Field></div>
        </div>
      )}
    </div>
  );
}

export function StepDojo({ d, set }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="col-span-2"><Field label="École / dojo *"><Txt k="school_name" d={d} set={set} /></Field></div>
      <Field label="Ville"><Txt k="school_city" d={d} set={set} /></Field>
      <Field label="Entraîneur responsable"><Txt k="coach_name" d={d} set={set} /></Field>
      <div className="col-span-2"><Field label="Numéro d'adhésion (fédération) si applicable"><Txt k="federation_number" d={d} set={set} /></Field></div>
    </div>
  );
}

export function StepProfil({ d, set }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field label="Années d'expérience"><Txt k="experience_years" d={d} set={set} type="number" /></Field>
      <Field label="Combats / compétitions antérieurs"><Txt k="previous_fights" d={d} set={set} type="number" /></Field>
      <div className="col-span-2"><Field label="Niveau général" hint="La ceinture par discipline se choisit à l'étape suivante.">
        <select data-testid="jm-level" value={d.level || ""} onChange={(e) => set("level", e.target.value)} className={inp}>
          <option value="">—</option><option value="debutant">Débutant</option><option value="intermediaire">Intermédiaire</option><option value="avance">Avancé</option>
        </select></Field></div>
    </div>
  );
}

export function StepDisciplines({ d, set, event, pricing }) {
  const entries = d.entries || [];
  const toggle = (disc) => {
    const has = entries.find((e) => e.discipline === disc);
    set("entries", has ? entries.filter((e) => e.discipline !== disc) : [...entries, { discipline: disc, belt_level: "blanche", experience_years: "" }]);
  };
  const setBelt = (disc, belt) => set("entries", entries.map((e) => (e.discipline === disc ? { ...e, belt_level: belt } : e)));
  const approvalFrom = event?.manual_approval_from || 3;
  return (
    <div className="space-y-3">
      {(event?.disciplines || []).map((disc) => {
        const sel = entries.find((e) => e.discipline === disc);
        return (
          <div key={disc} className={`rounded-xl border p-3 ${sel ? "border-red-500 bg-red-500/10" : "border-white/10 bg-white/5"}`}>
            <label className="flex items-center gap-3 cursor-pointer">
              <input type="checkbox" data-testid={`jm-disc-${disc}`} checked={!!sel} onChange={() => toggle(disc)} className="w-4 h-4 accent-[#D90429]" />
              <span className="font-medium">{DISCIPLINE_LABEL[disc] || disc}</span>
            </label>
            {sel && (
              <div className="mt-2 flex items-center gap-2 text-xs">
                <span className="text-zinc-400">Ceinture / grade :</span>
                <select data-testid={`jm-belt-${disc}`} value={sel.belt_level} onChange={(e) => setBelt(disc, e.target.value)} className="rounded-lg bg-zinc-900 border border-white/10 p-1.5 text-xs">
                  {BELTS.map((b) => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
            )}
          </div>
        );
      })}
      {entries.length >= approvalFrom && (
        <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 text-xs text-amber-100" data-testid="jm-multi-warning">
          ⚠️ À partir de {approvalFrom} disciplines, l'organisateur doit approuver ton inscription (horaire, récupération, conflits). Recommandation : 2 disciplines maximum le même jour.
        </div>
      )}
      {pricing && <div className="text-sm text-zinc-300" data-testid="jm-pricing-preview">{pricing.n} discipline(s) · <b>{pricing.subtotal.toFixed(2)} $</b> + taxes = {pricing.total.toFixed(2)} $</div>}
    </div>
  );
}

export function StepPoids({ d, set }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field label="Poids déclaré (kg) *"><Txt k="athlete_weight_kg" d={d} set={set} type="number" /></Field>
      <Field label="Date de la pesée"><Txt k="weight_date" d={d} set={set} type="date" /></Field>
      <p className="col-span-2 text-xs text-zinc-400">La catégorie est <b>provisoire</b> jusqu'à la pesée officielle le jour de l'événement.</p>
    </div>
  );
}

export function StepDispo({ d, set }) {
  const a = d.availability || {};
  const setA = (k, v) => set("availability", { ...a, [k]: v });
  return (
    <div className="grid grid-cols-2 gap-3">
      <Field label="Heure d'arrivée prévue"><input data-testid="jm-arrival" value={a.arrival || ""} onChange={(e) => setA("arrival", e.target.value)} className={inp} placeholder="ex. 8h30" /></Field>
      <Field label="Journées disponibles"><input data-testid="jm-days" value={a.days || ""} onChange={(e) => setA("days", e.target.value)} className={inp} placeholder="Samedi" /></Field>
      <div className="col-span-2"><Field label="Contraintes réelles (transport, autre compétition…)"><textarea data-testid="jm-constraints" value={a.constraints || ""} onChange={(e) => setA("constraints", e.target.value)} className={`${inp} min-h-[70px]`} /></Field></div>
    </div>
  );
}

export function StepSante({ d, set, docs, onUpload, onDeleteDoc }) {
  return (
    <div className="space-y-3">
      <Field label="Personne à contacter en urgence (nom + téléphone) *"><Txt k="emergency_contact" d={d} set={set} /></Field>
      <Field label="Déclaration médicale / allergies"><textarea data-testid="jm-medical_notes" value={d.medical_notes || ""} onChange={(e) => set("medical_notes", e.target.value)} className={`${inp} min-h-[70px]`} placeholder="Aucune condition connue, allergies, médication…" /></Field>
      <Check k="non_pregnancy" d={d} set={set} label="Déclaration de non-grossesse (si applicable)" />
      <div className="rounded-xl border border-white/10 bg-white/5 p-3" data-testid="jm-docs-block">
        <div className="text-xs uppercase tracking-widest text-zinc-400 mb-2">Documents confidentiels (accès restreint à l'organisateur)</div>
        <div className="flex flex-wrap gap-2 items-center">
          <select id="jm-doc-type" data-testid="jm-doc-type" className="rounded-lg bg-zinc-900 border border-white/10 p-2 text-xs" defaultValue="medical">
            <option value="medical">Certificat médical</option><option value="id_proof">Pièce d'identité</option><option value="federation">Carte fédération</option><option value="consent">Consentement signé</option><option value="other">Autre</option>
          </select>
          <input type="file" data-testid="jm-doc-file" accept=".pdf,.jpg,.jpeg,.png,.heic" onChange={(e) => { const f = e.target.files?.[0]; if (f) onUpload(document.getElementById("jm-doc-type").value, f); e.target.value = ""; }} className="text-xs" />
        </div>
        <ul className="mt-2 space-y-1 text-xs" data-testid="jm-docs-list">
          {(docs || []).map((x) => (
            <li key={x.id} className="flex items-center justify-between gap-2 rounded-lg bg-black/30 px-2 py-1.5">
              <span>🔒 {x.type} · {x.filename} <span className="text-zinc-500">({Math.round(x.size / 1024)} Ko)</span> {x.status === "verified" && <span className="text-emerald-300">✓ vérifié</span>}</span>
              <button type="button" onClick={() => onDeleteDoc(x.id)} className="text-red-300 hover:text-red-200" data-testid={`jm-doc-del-${x.id}`}>retirer</button>
            </li>
          ))}
          {!(docs || []).length && <li className="text-zinc-500">Aucun document téléversé (facultatif sauf si exigé par la discipline).</li>}
        </ul>
      </div>
    </div>
  );
}

export function StepReglements({ d, set, rules }) {
  const acc = d.accepted_rule_ids || [];
  const toggle = (id) => set("accepted_rule_ids", acc.includes(id) ? acc.filter((x) => x !== id) : [...acc, id]);
  return (
    <div className="space-y-3">
      {(rules || []).map((r) => (
        <div key={r.id} className="rounded-xl border border-white/10 bg-white/5 p-3" data-testid={`jm-rule-${r.id}`}>
          <div className="flex justify-between gap-2 text-sm font-medium"><span>{r.title}</span><span className="text-[11px] text-zinc-500">v{r.version} · révisé {r.revised_at}</span></div>
          <div className="mt-2 max-h-36 overflow-y-auto text-[12px] text-white/70 whitespace-pre-line">{r.body_md}</div>
          {r.source_url && <a href={r.source_url} target="_blank" rel="noreferrer" className="text-[11px] text-sky-300 underline">Source officielle</a>}
          <label className="mt-2 flex items-start gap-2 text-sm cursor-pointer">
            <input type="checkbox" data-testid={`jm-rule-accept-${r.id}`} checked={acc.includes(r.id)} onChange={() => toggle(r.id)} className="w-4 h-4 mt-0.5 accent-[#D90429]" />
            <span>J'ai lu et j'accepte ce règlement (version {r.version}).</span>
          </label>
        </div>
      ))}
      {!(rules || []).length && <p className="text-sm text-zinc-400">Aucun règlement publié pour ces disciplines — l'organisateur les ajoutera avant l'événement.</p>}
    </div>
  );
}

export function StepAutorisations({ d, set, event }) {
  const minor = (ageAt(d.athlete_dob, event?.date) ?? 18) < 18;
  return (
    <div className="space-y-3">
      <Check k="photo_consent" d={d} set={set} label="J'autorise la prise de photos/vidéos pendant l'événement (diffusion dojo et réseaux, sans nom complet des mineurs)." />
      <Check k="data_consent" d={d} set={set} label="J'accepte que mes données soient utilisées uniquement pour l'organisation de l'événement (Loi 25 — minimisation)." />
      {minor && <Check k="parental_consent" d={d} set={set} label="Je suis le parent / tuteur légal et j'autorise la participation de l'athlète mineur." />}
      <Check k="waiver_accepted" d={d} set={set} label="Décharge de responsabilité : je reconnais les risques inhérents aux sports de combat et je dégage l'organisation dans le cadre normal de la pratique. *" />
      <Field label="Signature électronique (nom complet) *"><Txt k="waiver_signature_text" d={d} set={set} placeholder={d.parent_name || `${d.athlete_first_name || ""} ${d.athlete_last_name || ""}`} /></Field>
      <p className="text-[11px] text-zinc-500">Signature horodatée avec la version des règlements acceptés.</p>
    </div>
  );
}
